import React from "react";

export default function BlockingActionModal({ isOpen, onComplete, onCancel }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <h2 className="text-lg font-semibold text-slate-900">
          Profile completion required
        </h2>
        <p className="mt-3 text-sm text-slate-600">
          Your profile is incomplete. Some features are unavailable until your
          profile is completed.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={onComplete}>
            Complete Profile
          </button>
        </div>
      </div>
    </div>
  );
}
